<div class="flex-grow leading-6 text-sm">
  <div class="flex" [class.flex-col]="!isClamped || lines > 1">
    <div class="flex-grow">
      <div
        data-cy="clamp-content"
        class="clamp-content"
        [ngClass]="{
          'line-clamp-1': lines === 1,
          'line-clamp-2': lines === 2,
          'line-clamp-3': lines === 3,
          'line-clamp-4': lines === 4,
          'line-clamp-5': lines === 5,
          'line-clamp-6': lines === 6,
          'line-clamp-7': lines === 7,
          'line-clamp-8': lines === 8,
          'line-clamp-9': lines === 9,
          'line-clamp-10': lines === 10
        }"
        [class.line-clamp-none]="!clamp || !isClamped"
        [class.unreset]="unreset"
        #bannerContent
        (cdkObserveContent)="onContentChange()"
      >
        <ng-content></ng-content>
      </div>
    </div>
    <div
      *ngIf="clamp && hasClamp"
      class="clamp-controls shrink text-right"
      data-cy="clamp-controls"
    >
      <!-- Show More -->
      <button
        class="text-palette-m3-system-blue-40 background-transparent whitespace-nowrap text-sm ml-1 underline"
        [class.inline-block]="isClamped"
        type="button"
        data-cy="clamp-show-more-link"
        (click)="onShowMore($event)"
      >
        {{ showMoreText }}
      </button>
      <!-- Show Less -->
      <button
        class="text-palette-m3-system-blue-40 background-transparent whitespace-nowrap text-sm ml-1 underline"
        [class.inline-block]="!isClamped"
        type="button"
        data-cy="clamp-show-less-link"
        (click)="onShowLess($event)"
      >
        {{ showLessText }}
      </button>
    </div>
  </div>
</div>
